export const APP_NAME = {
  WHATSAPP: "WhatsApp",
  LINE: "Line",
  SMS: "SMS"
};

export const LOGIN_METHOD = {
  WHATSAPP: "WHATSAPP",
  TWILIO_WHATSAPP: "TWILIO_WHATSAPP",
  LINE_PHONE_NUMBER: "LINE_PHONE_NUMBER",
  LINE_ADCOINZ_PHONE_NUMBER: "LINE_ADCOINZ_PHONE_NUMBER",
  LINE_SSO: "LINE_SSO",
  LINE_SESSION_ID: "LINE_SESSION_ID",
  LINE_ADCOINZ_SESSION_ID: "LINE_ADCOINZ_SESSION_ID",
  LINE_TW: "LINE_TW",
  SMS: "SMS",
  LINE_LIFF_SR: "LINE_LIFF_SR",
  LINE_LIFF_ADCOINZ: "LINE_LIFF_ADCOINZ",
  LINE_LIFF_TAIWAN: "LINE_LIFF_TAIWAN"
};

export const LIST_LANGUAGE_ENUM = {
  EN: "en",
  ZHHK: "zh-HK",
  ZHTW: "zh-TW",
  JA: "ja"
};

export const SUB_CAMPAIGN_ID_KEY = "subcampaign_id";

export const QR_SCANLOG_ID = "qrscanlog_id";

export const CHANNEL = "channel";

export const LOCAL_STORAGE_KEY_CURRENT_LANGUAGE = "i18nextLng";

export const COUPON_ID = "coupon_id";

export const ENGAGE_GET_CREDIT_SESSION = "engage-get-credit";

export const CHANNEL_SESSION_ID = "channel_session_id";
